var Assam = "阿薩姆邦";
var Bihar = "比哈爾邦";
var Chandigarh = "昌迪加爾";
var Chhattisgarh = "切蒂斯格爾邦";
var Delhi = "德里";
var Goa = "果阿邦";
var Gujarat = "古吉拉特邦";
var Haryana = "哈里亞納邦";
var Jharkhand = "賈坎德邦";
var Karnataka = "卡納塔克邦";
var Kerala = "喀拉拉邦";
var Lakshwadeep = "拉克什瓦迪普";
var Maharashtra = "馬哈拉什特拉邦";
var Manipur = "曼尼普爾邦";
var Meghalaya = "梅加拉亞邦";
var Mizoram = "米佐拉姆邦";
var Nagaland = "那加蘭邦";
var Orrisa = "奧里薩邦";
var Puducherry = "朋迪治里";
var Punjab = "旁遮普邦";
var Rajasthan = "拉賈斯坦邦";
var Sikkim = "錫金邦";
var Telangana = "泰倫加納邦";
var Tripura = "特里普拉邦";
var Uttrakhand = "北阿坎德邦";
var INStates = {
	"Andaman and Nicobar Islands": "安達曼和尼科巴群島",
	"Andhra Pradesh": "安德拉邦",
	"Arunachal Pradesh": "阿魯那恰爾邦",
	Assam: Assam,
	Bihar: Bihar,
	Chandigarh: Chandigarh,
	Chhattisgarh: Chhattisgarh,
	"Dadra & Nagar Haveli": "達德拉-納加爾哈維利",
	"Daman & Diu": "達曼-第烏",
	Delhi: Delhi,
	Goa: Goa,
	Gujarat: Gujarat,
	Haryana: Haryana,
	"Himachal Pradesh": "喜馬偕爾邦",
	"Jammu and Kashmir": "查謨和喀什米爾",
	Jharkhand: Jharkhand,
	Karnataka: Karnataka,
	Kerala: Kerala,
	Lakshwadeep: Lakshwadeep,
	"Madhya Pradesh": "中央邦",
	Maharashtra: Maharashtra,
	Manipur: Manipur,
	Meghalaya: Meghalaya,
	Mizoram: Mizoram,
	Nagaland: Nagaland,
	Orrisa: Orrisa,
	Puducherry: Puducherry,
	Punjab: Punjab,
	Rajasthan: Rajasthan,
	Sikkim: Sikkim,
	"Tamil Nadu": "坦米爾納德邦",
	Telangana: Telangana,
	Tripura: Tripura,
	"Uttar Pradesh": "北方邦",
	Uttrakhand: Uttrakhand,
	"West Bengal": "西孟加拉邦"
};

export { Assam, Bihar, Chandigarh, Chhattisgarh, Delhi, Goa, Gujarat, Haryana, Jharkhand, Karnataka, Kerala, Lakshwadeep, Maharashtra, Manipur, Meghalaya, Mizoram, Nagaland, Orrisa, Puducherry, Punjab, Rajasthan, Sikkim, Telangana, Tripura, Uttrakhand, INStates as default };
